// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3-OAU","modalForm":"UpgradeEpcsModal_modalForm__3Mh9C","modalFooter":"UpgradeEpcsModal_modalFooter__2NiDS"};